/* eslint-disable no-restricted-imports */
import { useDppEvents } from 'integration/hooks/useDppEvents';
import { useActivatePendingRepurchaseCoupon } from '@/data/Content/RepurchaseCouponState';
import { useApplyPendingCoupons } from '@/data/Content/AccountCoupons';
import { PERSONALIZATION_URL_KEYS } from '@/data/Content/RepurchaseCoupon';
import { useRemoveQueryParams } from 'integration/hooks/useRemoveQueryParams';

export const DppSync = () => {
	useDppEvents();
	useRemoveQueryParams(PERSONALIZATION_URL_KEYS);
	useActivatePendingRepurchaseCoupon();
	useApplyPendingCoupons();

	return null;
};
